// Состояние модалки Print Report: какие секции пользователь включает в PDF.
// Хранится в vuex (персистится через vuex-persistedstate, как и остальные
// модули), чтобы выбор не сбрасывался между открытиями модалки и
// перезагрузками.
//
// По умолчанию включена только секция Map (снимок карты с легендой +
// таблица Statistics под ним). Ключи соответствуют ключам реестра захвата
// (captureRegistry) и секциям сборщика PDF (buildReportPdf).

const state = {
  sections: {
    map: true,        // снимок карты OL с легендой + Statistics
    charts: false,    // графики Charts (ECharts)
    profiling: false, // профайлинг: графики ch3/ch4 + мета точки
  },
};

const getters = {
  reportSections: s => s.sections,
};

const mutations = {
  SET_REPORT_SECTION(state, { key, value }) {
    if (key in state.sections) state.sections[key] = !!value;
  },
};

const actions = {
  setReportSection({ commit }, payload) {
    commit('SET_REPORT_SECTION', payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
